<template>
  <div class="feedback-loading">
    <div class="feedback-loading__content">
      <div class="text-base-100">
        {{ $i18nPresenter.t("Just a moment! Generating your quiz...") }}
      </div>
      <FakeProgressbar :resetProgressBar="resetProgressBar" />
    </div>
  </div>
</template>

<script>
import FakeProgressbar from '@/components-v2/presentation-editor/new-slide/FakeProgressbar.vue'

export default {
  components: {
    FakeProgressbar,
  },
  props: {
    resetProgressBar: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
  .feedback-loading {
    @apply flex items-center justify-center mb-8;
    .feedback-loading__content {
      margin-top: 1.5rem;
    }
  }
</style>
